// extracted by mini-css-extract-plugin
export default {"container":"iQ5Up8","button":"de_ceo","icon":"r2jq4e","tooltipInner":"M54HBC","tooltipText":"jKZxqi","tooltip":"O_YrOK"};